<script>
  export let onClickFunction = ()=> (opened = true);
</script>

<button class="info" on:click={ onClickFunction }>
  <p><i class="fa-solid fa-circle-info"></i>Info</p>
</button>


<style>
  button {
  background-color: transparent;
  border: none;
  height: fit-content;
  line-height: 1.2;
  position: relative;
  z-index: 20;
  }
  button p{
  margin:0;
  }
  button p i {
  display: block;
  color: var(--uc-red);
  }
</style>